module.exports = require("@splunk/visualization-context/ImageContext");